import { render, staticRenderFns } from "./CrowdSettingsPayPerBrandTable.vue?vue&type=template&id=7ddc53c5&scoped=true"
import script from "./CrowdSettingsPayPerBrandTable.vue?vue&type=script&lang=js"
export * from "./CrowdSettingsPayPerBrandTable.vue?vue&type=script&lang=js"
import style0 from "./CrowdSettingsPayPerBrandTable.vue?vue&type=style&index=0&id=7ddc53c5&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ddc53c5",
  null
  
)

export default component.exports